import React from "react";
import "./ResultScreen.css";

export default function ResultScreen({
  score,
  totalQuestions,
  pointsPerCorrect,
  percentage,
  passed,
  feedback,
  onRestart,
  ctaLabel = "Play Again",
  children,
}) {
  const maxScore = totalQuestions * pointsPerCorrect;

  return (
    <section className="result-screen">
      <h2>{passed ? "Great Job!" : "Keep Improving!"}</h2>
      <p className="result-score">
        Score: {score} / {maxScore} ({percentage}%)
      </p>
      <p className="result-feedback">{feedback}</p>
      {children}
      <button type="button" className="result-btn" onClick={onRestart}>
        {ctaLabel}
      </button>
    </section>
  );
}
